import React, { memo } from 'react';

import { SelectOptionLozenge } from './select-option-lozenge.tsx';
import { type SelectReadContent } from './select-read-content.ts';
import styles from './select-value-view.module.css';

/**
 * Shared value presentation; the consumer owns empty placeholders and surrounding chrome.
 */
export const SelectValueView = memo(function SelectValueView({
  content,
  showDisabledValue = false
}: {
  readonly content: SelectReadContent;
  readonly showDisabledValue?: boolean;
}) {
  if (content.options.length === 0) {
    return null;
  }

  return (
    <div data-testid="select-read-value" className={styles.options}>
      {content.options.map((option, index) => (
        <SelectOptionLozenge
          key={`${option.key}:${index}`}
          label={option.label}
          color={option.color}
          testId={`database-select-option-tag-${option.label.replace(/\s+/g, '-').toLowerCase()}`}
          showDisabledValue={showDisabledValue}
        />
      ))}
    </div>
  );
});
